<div obgAccordion *ngIf="currentFlag$ | async as currentFlag">
	<div
		*ngIf="currentFlag"
		class="flag-item current"
		[obgInteraction]="getLanguageItemPayload()"
		key="language-selector"
		obgAccordionHeader
	>
		<img
			class="image-container"
			*ngIf="currentFlag.image?.url"
			[src]="currentFlag.image?.url"
			loading="lazy"
			[title]="currentFlag.image?.altText || currentFlag.name"
		/>
		<span class="flag-name">{{ currentFlag.name }}</span>
		<span class="ico-arrow-down"></span>
	</div>
	<obg-accordion-content *ngIf="flags$ | async as flags" key="language-selector" hideOnly>
		<ng-container *ngFor="let flag of flags; trackBy: flagTrackBy">
			<a
				*ngIf="flag && flag.name"
				class="flag-item"
				(click)="languageClick(flag)"
				[obgRouteLink]="{url: flag.href}"
				[obgRouteLinkOptions]="{disableComponentSharing: true}"
				[obgInteraction]="getLanguageItemPayload(flag)"
				[class.selected]="currentFlag && flag.iconTag === currentFlag.iconTag"
				attr.test-id="language-selector-{{flag.name}}-link"
				attr.data-test-id="language-selector-{{flag.name}}-link"
			>
				<img
					class="image-container"
					*ngIf="flag.image?.url"
					[src]="flag.image?.url"
					[title]="flag.image?.altText || flag.name"
					loading="lazy"
				/>
				<span>{{ flag.name }}</span>
			</a>
		</ng-container>
	</obg-accordion-content>
</div>
